//Functions to handle room Data

const getUniqueRoomsFromInventory = (inventory: any) => {
  const uniqueRoomsArray = inventory.reduce(
    (accumulator: any, current: any) => {
      const existingRoom = accumulator.find(
        (item: any) => item.room === current.room
      );

      if (!existingRoom) {
        accumulator.push({
          room: current.room,
          index: accumulator.length + 1, // Adding a unique index
          text: current.room,
          cubes: current.cubes,
          itemId: current.itemId,
        });
      }

      return accumulator;
    },
    []
  );

  return uniqueRoomsArray;
};

const setItemsUnderRoom = (inventory: any) => {
  const roomObject = inventory.reduce(
    (accumulator: any, current: any, index: any) => {
      const { item, quantity, room, cubes, itemId } = current;

      if (!accumulator[room]) {
        accumulator[room] = [];
      }

      accumulator[room].push({
        item,
        quantity,
        text: item,
        index: index + 1, // Adding 1 to make the index start from 1
        cubes: cubes,
        itemId: itemId,
        room: room,
      });

      return accumulator;
    },
    {}
  );

  return roomObject
};

export { getUniqueRoomsFromInventory,setItemsUnderRoom };
